var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"layout"},[_vm._t("default"),_c('div',[_vm._v("Copyright ©"+_vm._s(_vm.timeLimit)+" fe_bean")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }